import script from "./meetingAffairs.vue?vue&type=script&lang=ts&setup=true"
export * from "./meetingAffairs.vue?vue&type=script&lang=ts&setup=true"

import "./meetingAffairs.vue?vue&type=style&index=0&id=4045a657&lang=less&scoped=true"

import exportComponent from "D:\\test\\ieds-user-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4045a657"]])

export default __exports__